"use client";

import type { CSSProperties } from "react";

function SkeletonBar({
  className,
  style,
}: {
  className: string;
  style?: CSSProperties;
}) {
  return (
    <div
      className={`rounded bg-contrast/6 shimmer shimmer-bg text-foreground ${className}`}
      style={style}
    />
  );
}

export function NotesSkeleton() {
  return (
    <div className="flex w-full flex-col gap-2.5 items-start px-4 sm:px-8 py-4 sm:py-6 border-b border-border">
      <div className="flex items-center py-1.5 w-full">
        <SkeletonBar className="h-[18px] w-[50px]" />
      </div>
      {/* Textarea placeholder */}
      <SkeletonBar className="h-[88px] w-full !rounded-lg" />
      <div className="flex w-full items-center justify-between">
        <SkeletonBar className="h-3.5 w-[180px]" />
        <SkeletonBar className="h-7 w-[80px] !rounded-md" />
      </div>
    </div>
  );
}
